import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { authHeader, getLogUserId } from "./MainFunction";
import { useToast } from "./CustomMessages";
import { getLoggedUserDetails } from "../../redux/action";
import { DASHBOARD_ROUTE } from "../../constants/RoutePath";
import dayjs from "dayjs";

const SIGNIN_ROUTE = "/signin";
const SESSION_TIMEOUT = 15 * 60 * 1000; // 15 minutes

const useSessionHandler = (val) => {
  const showToast = useToast();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const logoutChannel = new BroadcastChannel("logout-channel");
  const loginChannel = new BroadcastChannel("login-channel");
  let token = authHeader();

  useEffect(() => {
    if (token.Authorization != null) {
      dispatch(getLoggedUserDetails());
    }
  }, [token.Authorization, dispatch]);

  const checkSessionTimeout = () => {
    const API_TIME = localStorage.getItem("API_TIME");
    if (!API_TIME) return;

    const lastUpdateTime = new Date(API_TIME).getTime();
    const currentTime = new Date().getTime();
    const timeDifference = currentTime - lastUpdateTime;

    if (timeDifference > 1800000) {  //30 mintues  = 1800000  15 minuntes == 900000 //1 min = 60000  //
      showToast("Session expired", "error");     
      localStorage.setItem("SESSION_TIMEOUT", true);
      setTimeout(() => {
        userLogout();
      }, 1000);
    }
  };

  const handleUserActivity = () => {
    localStorage.setItem("API_TIME", dayjs().tz("America/New_York").format());
  };

  const userLogout = async () => {
    window.location.reload()
    localStorage.setItem("logout", Date.now());
    localStorage.removeItem("API_TIME");
    localStorage.clear();
    logoutChannel.postMessage("logout");
    window.location.pathname = SIGNIN_ROUTE;
  };

  if (val && val.userId && getLogUserId()) {
    if (val.userId === getLogUserId() && val.active === 0) {
      showToast("Your account has been deactivated by the admin.", "error");
      userLogout();
    }
  }

  useEffect(() => {
    const intervalId = setInterval(checkSessionTimeout, 1000);
    return () => clearInterval(intervalId);
  }, []);

  useEffect(() => {
    const handleStorageEvent = (event) => {
      if (event.key === "logout" && document.hidden) {
        window.location.pathname = SIGNIN_ROUTE;
      } else if (event.key === "loginEvent" && document.hidden) {
        window.location.reload(); // Reload the tab to update the login state
      }
    };
  
    const handleLogoutMessage = (message) => {
      if (message.data === "logout" && document.hidden) {
        window.location.pathname = SIGNIN_ROUTE;
      }
    };
  
    const handleLoginMessage = (message) => {
      if (message.data === "login" && document.hidden) {
        window.location.reload(); // Reload the tab to update the login state
      }
    };
  
    window.addEventListener("storage", handleStorageEvent);
    logoutChannel.addEventListener("message", handleLogoutMessage);
    loginChannel.addEventListener("message", handleLoginMessage);
  
    return () => {
      window.removeEventListener("storage", handleStorageEvent);
      logoutChannel.removeEventListener("message", handleLogoutMessage);
      loginChannel.removeEventListener("message", handleLoginMessage);
    };
  }, []);
  
  
  

  useEffect(() => {
    document.addEventListener("click", handleUserActivity);
    document.addEventListener("keydown", handleUserActivity);

    return () => {
      document.removeEventListener("click", handleUserActivity);
      document.removeEventListener("keydown", handleUserActivity);
    };
  }, []);
};

export default useSessionHandler;
